import { z } from 'zod/v3';
import { DataObjectGroupType } from '../types';

export const zDataObjectGroupType = z.nativeEnum(DataObjectGroupType);
